import { Get, Post } from '@/utils/axios'

// 采购单列表
export function GetPurchaseOrderList(data) {
  return Post('/Purchase/GetPurchaseOrderList', data)
}
// 创建采购单
export function CreatePurchaseOrder(data) {
  return Post('/Purchase/CreatePurchaseOrder', data)
}
// 添加采购单明细（单条）
export function PurchaseOrderAddSingleItem(data) {
  return Post('/Purchase/PurchaseOrderAddSingleItem', data)
}
// 删除采购单明细（单条）
export function PurchaseOrderDeleteItem(data) {
  return Post('/Purchase/PurchaseOrderDeleteItem', data)
}
// 修改采购单明细
export function PurchaseOrderAddItem(data) {
  return Post('/Purchase/PurchaseOrderAddItem', data)
}
// 取消采购单
export function CancelPurchaseOrder(data) {
  return Post('/Purchase/CancelPurchaseOrder', data)
}
// 获取最后一次采购价格
export function GetLastPurchasePrice(data) {
  return Post('/Purchase/GetLastPurchasePrice', data)
}
// 修改采购单
export function UpdatePurchaseOrder(data) {
  return Post('/Purchase/UpdatePurchaseOrder', data)
}
// 采购单详情
export function GetPurchaseOrder(data) {
  return Post('/Purchase/GetPurchaseOrder', data)
}
// 到货通知列表
export function GetNoReadNotice(data) {
  return Post('/Purchase/GetNoReadNotice', data)
}
// 到货通知详情
export function GetNoReadNoticeInfo(data) {
  return Get('/Purchase/GetNoReadNoticeInfo', data)
}
// 阅读到货通知
export function ReadPurchaseNotice(data) {
  return Post('/Purchase/ReadNotice', data)
}
// 追加物流信息
export function AddAppPurchaseOrderTrail(data) {
  return Post('/Purchase/AddAppPurchaseOrderTrail', data)
}

